import { flatMap } from 'lodash'

export const interleave = <T, E>(arr: T[], element: E) => flatMap(arr, (e) => [e, element]).slice(0, -1)
